export default __webpack_public_path__ + "static/media/L_LVT.18a677d6.jpg";